import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom'; 
import { Grid, createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material';
import PageLink from './components/common/PageLink';
import ChatBox from './components/common/ChatBox';
import FilmhookCinemaSplashIntro from './components/common/FilmhookCinemaSplashIntro';
import ScrollToTop from './components/common/ScrollToTop';
import { ThemeProvider } from './ThemeContext';

const muiTheme = createTheme({
  typography: {
    fontFamily: '"Bricolage Grotesque", "Inter", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider>
      <MUIThemeProvider theme={muiTheme}>
        <Router> 
          <ScrollToTop />
          <FilmhookCinemaSplashIntro />
          <Grid>
            <PageLink />
            <ChatBox/>
          </Grid>
        </Router>
      </MUIThemeProvider>
    </ThemeProvider>
  );
}

export default App;
